export default {
  BusinessReport: '业务报表',
  Tips: '您可根据需要选择时间段，生成报表。业务报表涉及数据量大，打包预计1-3分钟，完成后您可直接在线查看或下载。',
  ExportReport: '导出报表',
  Type: '类型',
  ReportTime: '报表时间',
  ApplicationExportTime: '申请导出时间',
  FileSize: '文件大小',
  Status: '状态',
  Options: '操作',
  View: '查看',
  Download: '下载',
  Delete: '删除',
  Cancel: '取消',
  CancelTask: '确定取消当前导出任务？',
  CancelTaskContent: '取消后不可恢复，如有需要可再次导出',
  DeleteReport: '确定删除当前报表？',
  DeleteReportContent: '删除后不可恢复，如有需要可再次导出',
}